/**
 * @file Sort related enums.
 */

/**
 * Sort directions enum.
 *
 * @enum SORT_DIRECTION
 * @type {{DESC: string, ASC: string}}
 */

export const SORT_DIRECTION = {
  DESC: 'DESC',
  ASC: 'ASC',
};

/**
 * Album Photo Groups Sort fields enum.
 *
 * @enum ALBUM_PHOTO_GROUPS_SORT
 * @type {{CREATED_AT: string}}
 */

export const ALBUM_PHOTO_GROUPS_SORT = {
  CREATED_AT: 'CREATED_AT',
};
